/** Sync API JSON envelope: `{ "data": { ... } }` (errors stay flat). */

export function wrapSyncApiEnvelope<T extends Record<string, unknown>>(data: T): { data: T } {
  return { data };
}

export function unwrapSyncApiEnvelope(body: unknown): Record<string, unknown> {
  if (!body || typeof body !== 'object' || Array.isArray(body)) return {};
  const record = body as Record<string, unknown>;
  const data = record.data;
  if (data != null && typeof data === 'object' && !Array.isArray(data)) {
    return data as Record<string, unknown>;
  }
  return record;
}
